import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import { BasePType, BehaviorSettings } from '@digital-platform/rs-cms/domain';

@Component({
  selector: 'digital-platform-base-ptype',
  standalone: true,
  imports: [CommonModule],
  template: '',
})
export class BasePTypeComponent implements BasePType {
  public id: BasePType['id'] = -1;
  public revisionId: BasePType['revisionId'] = -1;
  public type: BasePType['type'] = '';
  public status: BasePType['status'] = true;
  public parentType: BasePType['parentType'] = '';
  // Added for Layout Paragraphs:
  public uuid: BasePType['uuid'] = '';
  public behaviorSettings: BehaviorSettings = {};
}
